import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { errorText } from "@/lib/api";

// Al doilea pas al autentificării: codul de 6 cifre primit pe e-mail.
export default function MfaCodeForm({ token, info = {}, onDone, onBack }) {
  const { login2fa, resend2fa } = useAuth();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [busy, setBusy] = useState(false);
  const [wait, setWait] = useState(info.resend_seconds || 60);
  const [hint, setHint] = useState(info.email_hint || "");

  useEffect(() => {
    if (wait <= 0) return undefined;
    const t = setTimeout(() => setWait(w => w - 1), 1000);
    return () => clearTimeout(t);
  }, [wait]);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setNotice("");
    if (!/^\d{6}$/.test(code.trim())) return setError("Introduceți codul de 6 cifre din e-mail.");
    setBusy(true);
    try { await login2fa(token, code.trim()); onDone && onDone(); }
    catch (err) { setError(errorText(err, "Cod incorect")); }
    finally { setBusy(false); }
  };
  const resend = async () => {
    setError(""); setNotice(""); setBusy(true);
    try {
      const r = await resend2fa(token);
      setHint(r.email_hint || hint); setWait(r.resend_seconds || 60); setCode("");
      setNotice("Am trimis un cod nou. Cel vechi nu mai este valabil.");
    } catch (err) { setError(errorText(err, "Nu am putut retrimite codul")); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} data-testid="mfa-form" style={{ width: "100%", maxWidth: 380 }}>
      <h2 style={{ fontSize: 24, fontWeight: 700, margin: "0 0 6px" }}>Verificare în doi pași</h2>
      <p style={{ fontSize: 14, margin: "0 0 20px", opacity: 0.8 }} data-testid="mfa-hint">
        Am trimis un cod de 6 cifre pe e-mail{hint ? <> (<b>{hint}</b>)</> : ""}. Este valabil {info.code_minutes || 10} minute și se poate folosi o singură dată.
      </p>
      <label className="label label-req">Cod din e-mail</label>
      <input className="input" value={code} onChange={e => setCode(e.target.value)} autoFocus autoComplete="one-time-code"
        inputMode="numeric" maxLength={6} placeholder="123456" data-testid="mfa-code" />
      {notice && <div style={{ background: "#DCFCE7", color: "#14532D", padding: "10px 14px", borderRadius: 8, marginTop: 14, fontSize: 13 }} data-testid="mfa-notice">{notice}</div>}
      {error && <div style={{ background: "#FEE2E2", color: "#991B1B", padding: "10px 14px", borderRadius: 8, marginTop: 14, fontSize: 13 }} data-testid="mfa-error">{error}</div>}
      <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center", padding: "11px 16px", marginTop: 16 }}
        disabled={busy} data-testid="mfa-submit">{busy ? "Se verifică..." : "Continuă"}</button>
      <button type="button" className="btn btn-secondary" style={{ width: "100%", justifyContent: "center", marginTop: 8 }}
        disabled={busy || wait > 0} onClick={resend} data-testid="mfa-resend">
        {wait > 0 ? `Trimite un cod nou (în ${wait} s)` : "Trimite un cod nou"}
      </button>
      <button type="button" className="btn btn-ghost" style={{ width: "100%", justifyContent: "center", marginTop: 4 }}
        onClick={onBack} data-testid="mfa-back">Înapoi</button>
    </form>
  );
}
